import React from "react";

const RecurringPayments = () => {
  return (
    <div className="bg-gray-50 min-h-screen p-4 md:p-8">
      {/* Header */}
      <h1 className="text-2xl font-semibold text-gray-800 mb-4">
        Recurring payments
      </h1>

      {/* Description */}
      <div className="bg-white rounded-lg shadow border border-gray-200 p-4">
        <p className="text-gray-600 mb-4">
          Recurring payments are used for automatic renewal of consumable
          merchandise or subscription services. Learn more about{" "}
          <a
            href="#"
            className="text-blue-600 hover:underline"
          >
            recurring products
          </a>
          .
        </p>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-200 text-sm text-left">
            <thead className="bg-gray-100 text-gray-700">
              <tr>
                <th className="px-4 py-2 font-medium border-b">ID</th>
                <th className="px-4 py-2 font-medium border-b">Customer</th>
                <th className="px-4 py-2 font-medium border-b">Cycle length</th>
                <th className="px-4 py-2 font-medium border-b">Cycle period</th>
                <th className="px-4 py-2 font-medium border-b">Is active</th>
                <th className="px-4 py-2 font-medium border-b">Start date</th>
                <th className="px-4 py-2 font-medium border-b">Next payment date</th>
                <th className="px-4 py-2 font-medium border-b">Total cycles</th>
                <th className="px-4 py-2 font-medium border-b">Cycles remaining</th>
                <th className="px-4 py-2 font-medium border-b">Edit</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  colSpan="10"
                  className="text-center py-6 text-gray-500 border-b"
                >
                  No data available in table
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex flex-col sm:flex-row justify-between items-center mt-4 gap-2">
          <div className="flex items-center space-x-2">
            <button className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-3 py-1 rounded">
              Previous
            </button>
            <button className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-3 py-1 rounded">
              Next
            </button>
          </div>

          <div className="flex items-center space-x-2">
            <span className="text-gray-600">Show</span>
            <select className="border border-gray-300 rounded px-2 py-1">
              <option>5</option>
              <option>10</option>
              <option selected>15</option>
              <option>25</option>
            </select>
            <span className="text-gray-600">items</span>
          </div>
        </div>

        {/* No records footer */}
        <div className="text-center text-gray-500 mt-4">No records</div>
      </div>
    </div>
  );
};

export default RecurringPayments;
